import { useEffect } from "react";
import { notifications$ } from "services/subjects";

export function useNotifyError( 
    error: string | Error,
    friendlyMessage: string = 'An unexpected error occurred.'): void {
    useEffect(() => {
        if (!error) return;
        console.error(friendlyMessage, error);
        notifications$.next({
            severity: 'error',
            message: friendlyMessage,
        });
    }, [error]);
}